import { PublicAnnouncement } from '@/api/app-state/app-state.types.ts';

interface Props {
  announcement: PublicAnnouncement;
  onDismiss: (id: string) => void;
}

/** A single dismissible announcement bar. Variant drives the colour. */
export function AnnouncementBanner({ announcement, onDismiss }: Props) {
  const { id, title, body, variant, dismissible, ctaLabel, ctaUrl } =
    announcement;

  return (
    <div
      className={`eos-ann-banner eos-ann--${variant}`}
      role="status"
      aria-live="polite"
    >
      <div className="eos-ann-banner__body">
        <div className="eos-ann-banner__title">{title}</div>
        {body && <div className="eos-ann-banner__text">{body}</div>}
        {ctaLabel && ctaUrl && (
          <a
            className="eos-ann-banner__cta"
            href={ctaUrl}
            target={ctaUrl.startsWith('http') ? '_blank' : undefined}
            rel="noreferrer"
          >
            {ctaLabel}
          </a>
        )}
      </div>
      {dismissible && (
        <button
          type="button"
          className="eos-ann-banner__close"
          aria-label="Schließen"
          onClick={() => onDismiss(id)}
        >
          ×
        </button>
      )}
    </div>
  );
}
